import React from 'react';

export const EnvironmentBanner = () => {
  const environment = process.env.REACT_APP_ENVIRONMENT || process.env.NODE_ENV;
  
  if (environment === 'production') {
    return null; // No banner in production
  }
  
  return (
    <div className="dev-environment-banner">
      🚧 DEVELOPMENT MODE - Test emails use dev+ prefix (dev+test@whiskeyrebel.design)
    </div>
  );
};
